import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import cc from 'classcat';
import React, { useState } from 'react';
import { OV_CONCIERGE_API_KEY } from '../SMSSignUp/constants';
import Button from '../Button';
import css from './SignUp.module.scss';
import useScript from '../../utils/hooks/useScript';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var CONCIERGE_URL = 'https://assets.conciergeteam.co/js/sms-opt-in.js';

var SignUp = function SignUp() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      submitted = _useState2[0],
      setSubmitted = _useState2[1];

  useScript(CONCIERGE_URL);

  var onSubmit = function onSubmit(e) {
    if (submitted) {
      return false;
    }

    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    if (window.sendConFormData) {
      window.sendConFormData();
      setSubmitted(true);
      return false;
    }

    return true;
  };

  return /*#__PURE__*/_jsxs("form", {
    className: css.root,
    onSubmit: onSubmit,
    id: "customer-opt-in-form",
    children: [/*#__PURE__*/_jsxs("div", {
      className: cc([css.messageContainer, _defineProperty({}, css.submitted, submitted)]),
      children: [/*#__PURE__*/_jsxs("p", {
        className: css.message,
        children: ['Questions? ', /*#__PURE__*/_jsx("br", {
          className: css.mobile
        }), "Sign up for text messages to chat with our team directly."]
      }), /*#__PURE__*/_jsx("div", {
        id: "div-for-info",
        className: css.conciergeInfo
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: css.content,
      children: [/*#__PURE__*/_jsx("input", {
        className: css.hidden,
        name: "pk",
        value: OV_CONCIERGE_API_KEY,
        readOnly: true
      }), /*#__PURE__*/_jsx("input", {
        className: css.hidden,
        name: "utm_source",
        value: "tracking-page",
        readOnly: true
      }), /*#__PURE__*/_jsx("input", {
        className: cc([css.input, _defineProperty({}, css.inputDisabled, submitted)]),
        disabled: submitted,
        name: "phone_number",
        placeholder: "Enter Mobile Number",
        type: "tel",
        required: true
      }), /*#__PURE__*/_jsx(Button, {
        className: css.button,
        disabled: submitted,
        type: "submit",
        children: "Sign Up"
      })]
    })]
  });
};

export default SignUp;